module.exports = __webpack_public_path__ + "media/stylesheets/images/boxil/BOXIL Saas AWARD 2024_部門NO.1-36fb7feca2bb2d930138944b863a054d.png";